import {
  createNestablePublicClientApplication,
  Configuration,
  InteractionRequiredAuthError,
  IPublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";

let pca: IPublicClientApplication | undefined;

export async function initNaa(): Promise<IPublicClientApplication> {
  console.log("Initializing NAA...");

  if (pca) return pca;

  const config: Configuration = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
      supportsNestedAppAuth: true, // CRITICAL: This flag is required
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };

  pca = await createNestablePublicClientApplication(config);
  console.log("NAA initialized successfully");
  return pca;
}

export async function getToken(scopes: string[]): Promise<string | null> {
  try {

    if (!pca) {
      await initNaa();
    }

    // For NAA, don't rely on getAllAccounts() initially
    // Try acquireTokenSilent without specifying an account
    const tokenRequest: SilentRequest = {
      scopes: scopes,
      // NAA can work without explicit account - remove account parameter
    };

    console.log("Attempting silent token acquisition with NAA...");
    const result = await pca!.acquireTokenSilent(tokenRequest);
    console.log("Token acquired silently via NAA");
    return result.accessToken;
  } catch (error) {
    console.error("Silent token acquisition failed:", error);

    if (error instanceof InteractionRequiredAuthError) {
      // Fall back to interactive popup
      try {
        const result = await pca!.acquireTokenPopup({ scopes });
        return result.accessToken;
      } catch (popupError) {
        console.error("Popup authentication failed:", popupError);
        return null;
      }
    }

    return null;
  }
}
